import { combineReducers } from "redux"
// Front
import Layout from "./layout/reducer";

import blockchainReducer from "./blockchain/reducer";
import dataReducer from "./data/reducer";
import authReducer from "./auth/reducer";
import nftReducer from "./paymentnft/reducer";


const rootReducer = combineReducers({
  Layout,
  blockchain: blockchainReducer,
  data: dataReducer,
  auth:authReducer,
  paymentnft: nftReducer,
})

export default rootReducer
